/* eslint-disable no-underscore-dangle */

import { Plugin, Widget } from 'ckeditor5'

import { CommandName } from '../../types'
import InsertImportNotesTemplateCommand from './insertImportNotesTemplateCommand'

export default class ImportNotesTemplateEditing extends Plugin {
  static get requires() {
    return [Widget]
  }

  init() {
    this.editor.commands.add(
      CommandName.INSERT_IMPORT_NOTES_TEMPLATE,
      new InsertImportNotesTemplateCommand(this.editor),
    )
  }
}
